import type { CmtsHttpClient } from "../api/cmtsHttpClient.js";
import { CMTS_API, type TypedReportCode } from "../api/cmtsApiPaths.js";
import { mapTypedReport, mapExport } from "../mappers/reportMappers.js";
import { validateReportFilter } from "../validators/reportFilterValidators.js";
import { repositoryCall } from "./repositoryResult.js";

export function createTypedReportRepository(client: CmtsHttpClient) {
  return {
    query: (reportCode: TypedReportCode, payload: Record<string, unknown>) => repositoryCall(async () => {
      const d = validateReportFilter(payload);
      if (d.length) throw { success: false, message: "Report filter validation failed", errors: d.map((x) => ({ code: x.code, field: x.field, message: x.message })) };
      return mapTypedReport(await client.post<unknown>(CMTS_API.reports.typedQuery(reportCode), payload), reportCode);
    }, `CMTS_REPORT_${reportCode.toUpperCase()}_QUERY`),
    export: (reportCode: TypedReportCode, payload: Record<string, unknown>) => repositoryCall(async () => mapExport(await client.post<unknown>(CMTS_API.reports.typedExport(reportCode), payload)), `CMTS_REPORT_${reportCode.toUpperCase()}_EXPORT`),
    download: (id: string, tenantId?: string) => client.download(CMTS_API.reports.typedDownload(id), { query: { tenantId } })
  };
}
